import {
  actionTypes,
  officeRequestSuccess,
  officeRequestFailure,
  officeEntitlementRequestSuccess,
  officeEntitlementRequestFailure,
  entitlementRequestSuccess,
  entitlementRequestFailure,
  createRequestSuccess,
  createRequestFailure,
  chainEntitlementRequestFailure,
  chainEntitlementRequestSuccess,
  getPaginationTableStepOneSuccess,
  getPaginationTableStepOneFailure,
  getPaginationTableStepTwoSuccess,
  getPaginationTableStepTwoFailure,
  hideOuSuccess,
  hideOuFailure,
  showOuSuccess,
  showOuFailure,
  getSegregationsRequestActionSuccess,
  getSegregationsRequestActionFailure,
  deleteSegregationsRequestActionFailure,
  deleteSegregationsRequestActionSuccess,
  updateSegregationsRequestActionFailure,
  updateSegregationsRequestActionSuccess,
  addSegregationRequestActionFailure,
  addSegregationRequestActionSuccess,
  getAdminPaginatedGlobalCatalogActionSuccess,
  getAdminPaginatedGlobalCatalogActionFailure,
} from "./actions";

import {
  fetchCreateRequest,
  fetchEntitlementRequest,
  fetchOfficeEntitlementRequest,
  fetchOfficeRequest,
  fetchChainEntitlementRequest,
  fetchGetPaginationTableStepOne,
  fetchGetPaginationTableStepTwo,
  fetchShowOu,
  fetchHideOu,
  fetchSegregationsService,
  addSegregationService,
  deleteSegregationService,
  updateSegregationService,
  fetchAdminGlobalCatalog,
} from "./services";

import { ofType } from "redux-observable";
import { mergeMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";

const fetchGetPaginationTableStepOneEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_PAGINATION_TABLE_STEP_ONE),
    mergeMap((action: any) =>
      fetchGetPaginationTableStepOne(action.payload).pipe(
        map((response: any) => getPaginationTableStepOneSuccess(response)),
        catchError((error: any) => of(getPaginationTableStepOneFailure(error)))
      )
    )
  );

const fetchGetPaginationTableStepTwoEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_PAGINATION_TABLE_STEP_TWO),
    mergeMap((action: any) =>
      fetchGetPaginationTableStepTwo(action.payload).pipe(
        map((response: any) => getPaginationTableStepTwoSuccess(response)),
        catchError((error: any) => of(getPaginationTableStepTwoFailure(error)))
      )
    )
  );

const fetchHideOuEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.HIDE_OU),
    mergeMap((action: any) =>
      fetchHideOu(action.payload).pipe(
        map((response: any) => hideOuSuccess(response)),
        catchError((error: any) => of(hideOuFailure(error)))
      )
    )
  );

const fetchShowOuEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.SHOW_OU),
    mergeMap((action: any) =>
      fetchShowOu(action.payload).pipe(
        map((response: any) => showOuSuccess(response)),
        catchError((error: any) => of(showOuFailure(error)))
      )
    )
  );

const fetchGlobalCatalogEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADMIN_GLOBAL_CATALOG_REQUEST),
    mergeMap((action: any) =>
      fetchAdminGlobalCatalog(action.payload).pipe(
        map((response: any) =>
          getAdminPaginatedGlobalCatalogActionSuccess(response)
        ),
        catchError((error: any) =>
          of(getAdminPaginatedGlobalCatalogActionFailure(error))
        )
      )
    )
  );

const fetchOfficeRequestsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADMIN_OFFICE_CATALOG_REQUEST),
    mergeMap(() =>
      fetchOfficeRequest().pipe(
        map((response: any) => officeRequestSuccess(response)),
        catchError((error: any) => of(officeRequestFailure(error)))
      )
    )
  );

const fetchOfficeEntitlementRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADMIN_OFFICE_ENTITLEMENT_CATALOG_REQUEST),
    mergeMap((action: any) =>
      fetchOfficeEntitlementRequest(action.id).pipe(
        map((response: any) => officeEntitlementRequestSuccess(response)),
        catchError((error: any) => of(officeEntitlementRequestFailure(error)))
      )
    )
  );

const fetchEntitlementRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ENTITLEMENT_CATALOG_ADMIN_CONSOLE_REQUEST),
    mergeMap((action: any) =>
      fetchEntitlementRequest(action.obj).pipe(
        map((response: any) => entitlementRequestSuccess(response)),
        catchError((error: any) => of(entitlementRequestFailure(error)))
      )
    )
  );

const fetchCreateRequestCatalogEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADMIN_CREATE_CATALOG_REQUEST),
    mergeMap((action: any) =>
      fetchCreateRequest(action.payload).pipe(
        map((response: any) => createRequestSuccess(response)),
        catchError((error: any) => of(createRequestFailure(error)))
      )
    )
  );

const fetchChainEntitlementRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADMIN_CHAIN_ENTITLEMENT_REQUEST),
    mergeMap((action: any) =>
      fetchChainEntitlementRequest(action.payload).pipe(
        map((response: any) => chainEntitlementRequestSuccess(response)),
        catchError((error: any) => of(chainEntitlementRequestFailure(error)))
      )
    )
  );

const fetchSegregationsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_SEGREGATIONS_REQUEST),
    mergeMap(() =>
      fetchSegregationsService().pipe(
        map((response: any) => getSegregationsRequestActionSuccess(response)),
        catchError((error: any) =>
          of(getSegregationsRequestActionFailure(error))
        )
      )
    )
  );

const addSegregationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADD_SEGREGATION_REQUEST),
    mergeMap((action: any) =>
      addSegregationService(action.payload).pipe(
        map((response: any) => addSegregationRequestActionSuccess(response)),
        catchError((error: any) =>
          of(addSegregationRequestActionFailure(error))
        )
      )
    )
  );

const updateSegregationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.UPDATE_SEGREGATIONS_REQUEST),
    mergeMap((action: any) =>
      updateSegregationService(action.payload).pipe(
        map((response: any) =>
          updateSegregationsRequestActionSuccess(response)
        ),
        catchError((error: any) =>
          of(updateSegregationsRequestActionFailure(error))
        )
      )
    )
  );

const deleteSegregationsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_SEGREGATIONS_REQUEST),
    mergeMap((action: any) =>
      deleteSegregationService(action.payload).pipe(
        map((response: any) =>
          deleteSegregationsRequestActionSuccess(response)
        ),
        catchError((error: any) =>
          of(deleteSegregationsRequestActionFailure(error))
        )
      )
    )
  );

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  fetchOfficeRequestsEpic,
  fetchOfficeEntitlementRequestEpic,
  fetchEntitlementRequestEpic,
  fetchCreateRequestCatalogEpic,
  fetchChainEntitlementRequestEpic,
  fetchGetPaginationTableStepOneEpic,
  fetchGetPaginationTableStepTwoEpic,
  fetchGlobalCatalogEpic,
  fetchHideOuEpic,
  fetchShowOuEpic,
  addSegregationEpic,
  deleteSegregationsEpic,
  fetchSegregationsEpic,
  updateSegregationEpic,
];
